import React from "react";
import {
    Avatar,
    Button,
    Checkbox,
    Dropdown,
    Flex,
    Input,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import CardUser from "../../Cards/CardPositionEntreprise/CardUser";
import { AVATAR_DEFAULT } from "../../../../../constants";
import { useQuery } from "react-query";
import { _getAllManagers } from "../../../api";

const DialogUpdateSupervisorManager = ({
    manager,
    teamManager,
    onSelectionChange,
    setNewManager,
}) => {
    //* QUERY
    //* QUERY
    //* QUERY
    const {
        data: allManagers,
        isLoading: isLoadingAllManagers,
        isFetching: isFetchingAllManagers,
    } = useQuery(["getAllManagers"], () => _getAllManagers());

    // console.log("allManagers", allManagers);

    //* FUNCTIONS
    //* FUNCTIONS
    //* FUNCTIONS

    const initialState = teamManager?.reduce((acc, user) => {
        acc[user.id] = false;
        return acc;
    }, {});

    const [selectedUsers, dispatch] = React.useReducer(
        (state, action) => ({ ...state, ...action }),
        initialState
    );

    // React.useEffect(() => {
    //     const selected = teamManager.filter((user) => selectedUsers[user.id]);
    //     onSelectionChange(selected);
    // }, [selectedUsers, onSelectionChange]);

    //* sinon envoyer uniquement les id des user checked
    React.useEffect(() => {
        const selectedIds = Object.entries(selectedUsers)
            .filter(([_, isChecked]) => isChecked)
            .map(([id]) => parseInt(id));

        onSelectionChange(selectedIds);
    }, [selectedUsers, onSelectionChange]);
    //* sinon envoyer uniquement les id des user checked

    const values = Object.values(selectedUsers);
    const allSelected = values.every(Boolean);
    const someSelected = values.some(Boolean);
    const isMixed = allSelected ? true : someSelected ? "mixed" : false;

    // toggle alll checkBoxes
    const handleToggleAll = (_, { checked }) => {
        const updated = {};
        for (const id in selectedUsers) {
            updated[id] = checked;
        }
        dispatch(updated);
    };

    const handleToggleOne =
        (id) =>
        (_, { checked }) => {
            dispatch({ [id]: checked });
        };

    const selectedIds = Object.entries(selectedUsers)
        .filter(([_, isChecked]) => isChecked)
        .map(([id]) => parseInt(id));

    const selectedUserList = teamManager.filter((user) =>
        selectedIds.includes(user.id)
    );

    // console.log("Utilisateurs sélectionnés :", selectedUserList);

    // Tu peux remplacer ce console.log par un appel API ou autre
    // sendToAPI(selectedUserList)

    return (
        <Flex fill column>
            <Wrapper fill column gap="gap.medium">
                <Header column fill>
                    <InputLabel content="Manager d'origine" fluid />
                    <div>
                        <CardUser
                            avatar={manager?.avatar}
                            full_name={`${manager?.display_name}`}
                            job_title={manager?.job_title}
                            hideTitle={true}
                            // onClick={() =>
                            //     _navigateToEmployee(employee?.id)
                            // }
                        />
                    </div>
                </Header>
                <Flex column fill>
                    <InputLabel content="Manager destinataire" fluid />
                    <Dropdown
                        loading={isLoadingAllManagers || isFetchingAllManagers}
                        loadingMessage="Chargement des données ..."
                        noResultsMessage="Aucun résultat trouvé"
                        search
                        items={
                            allManagers?.map((employee) => {
                                return {
                                    id: employee?.id,
                                    key: employee?.id,
                                    header: `${employee?.first_name} ${employee?.last_name}`,
                                    content: employee?.job_title,
                                    image: employee?.avatar.length
                                        ? employee?.avatar
                                        : AVATAR_DEFAULT,
                                };
                            }) ?? []
                        }
                        placeholder="Choisissez une personne"
                        checkable
                        fluid
                        getA11ySelectionMessage={{
                            onAdd: (item) => `${item} has been selected.`,
                        }}
                        onChange={(_, newManager) => {
                            // console.log({ newManager: newManager.value });
                            setNewManager(newManager.value);
                        }}
                    />
                </Flex>
                <Flex
                    column
                    gap="gap.medium"
                    styles={{ paddingBottom: "30px" }}
                >
                    <InputLabel content="Personnes qui changeront de manager" />
                    <Flex
                        styles={{
                            height: "200px",
                            overflowY: "scroll",
                        }}
                        column
                        gap="gap.small"
                    >
                        <Checkbox
                            label="Toutes"
                            checked={isMixed}
                            onChange={handleToggleAll}
                        />
                        {teamManager?.map((user) => (
                            <Checkbox
                                key={user.id}
                                label={`${user.first_name} ${user.last_name}`}
                                checked={selectedUsers[user.id]}
                                onChange={handleToggleOne(user.id)}
                            />
                        ))}
                    </Flex>
                </Flex>
            </Wrapper>
        </Flex>
    );
};

export default DialogUpdateSupervisorManager;

const InputLabel = styled(Text)`
    color: #616161;
    font-family: "Segoe UI";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

const Header = styled(Flex)`
    padding-top: 35px;
`;

const Wrapper = styled(Flex)`
    /* height: 300px; */
    overflow-y: scroll;
    overflow-x: hidden;
    border-bottom: 1px solid #d1d1d1;
`;
